import { Certificate, KubernetesCertificate } from '../../../inventory/inventory.model';

export class CertificateManagementHelper {
  static countDaysTillCertificateExpiry(certificate: Certificate | KubernetesCertificate): number {
    const currentDate = new Date();
    const expireDate = new Date(certificate?.expires);
    return Math.floor((expireDate.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);
  }
}
